import { searchByName } from 'features/users/utils/searchByName';
import { UserId, UserName } from 'features/users/types';

export const searchUsers = <T extends { id: UserId; name: UserName }, R extends Record<UserId, T>>(
  userEntries: R,
  searchQuery: string
): R => {
  if (!searchQuery) {
    return userEntries;
  }

  const lowerCaseSearchQuery = searchQuery.toLowerCase();
  const result: Record<UserId, T> = {};

  for (const user of Object.values(userEntries)) {
    const userName = user.name?.toLowerCase();
    if (userName && searchByName(userName, lowerCaseSearchQuery)) {
      result[user.id] = user;
    }
  }

  return result as R;
};
